import i18n from "@/i18n";
import { IntercomProcedures, ParkingProcedures } from "@EspaceParkQC/sdk-call-center";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@EspaceParkQC/sdk-react";
import { FileText } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Fragment } from "react/jsx-runtime";

export default function Procedures(): React.ReactElement {
  const { t } = useTranslation("main");

  return (
    <Fragment>
      <div className="flex md:flex-row flex-col gap-6">
        <div className="flex flex-col gap-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="size-5" />
                {t("intercom.procedures.intercom.title")}
              </CardTitle>
              <CardDescription>{t("intercom.procedures.intercom.description")}</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <IntercomProcedures
                render={({ procedures }) =>
                  procedures && procedures.length > 0 ? (
                    <ul className="divide-y divide-border">
                      {procedures.map((procedure, index) => (
                        <li key={index} className="space-y-1.5 py-4 first:pt-0 last:pb-0">
                          <h2 className="text-sm font-bold">{procedure.issueDescription["en"]}</h2>
                          <p className="text-sm text-muted-foreground">{procedure.resolutionDescription["en"]}</p>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-sm text-muted-foreground">{t("intercom.procedures.intercom.no-procedures-available")}</p>
                  )
                }
              />
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText className="size-5" />
                {t("intercom.procedures.parking.title")}
              </CardTitle>
              <CardDescription>{t("intercom.procedures.parking.description")}</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <ParkingProcedures
                render={({ procedures }) =>
                  procedures && procedures.length > 0 ? (
                    <ul className="divide-y divide-border">
                      {procedures.map((procedure, index) => (
                        <li key={index} className="space-y-1.5 py-4 first:pt-0 last:pb-0">
                          <h2 className="text-sm font-bold">
                            {
                              procedure.issueDescription[
                                (i18n.language as keyof typeof procedure.issueDescription) in procedure.issueDescription
                                  ? (i18n.language as keyof typeof procedure.issueDescription)
                                  : "en"
                              ]
                            }
                          </h2>
                          <p className="text-sm">
                            {
                              procedure.resolutionDescription[
                                (i18n.language as keyof typeof procedure.resolutionDescription) in procedure.resolutionDescription
                                  ? (i18n.language as keyof typeof procedure.resolutionDescription)
                                  : "en"
                              ]
                            }
                          </p>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-sm text-muted-foreground">{t("intercom.procedures.parking.no-procedures-available")}</p>
                  )
                }
              />
            </CardContent>
          </Card>
        </div>
      </div>
    </Fragment>
  );
}
